import { useAvailableDays } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useAvailableDays'
import { useAvailableTimes } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useAvailableTimes'
import { useDay } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useDay'
import DaySelector from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/parts/Popover/parts/DaySelector'
import TimeSelector from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/parts/Popover/parts/TimeSelector'
import { DeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import DismissOverlayProvider from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import { useScreenSize } from '@/hooks/screen'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface PopoverProps {
    open: boolean
    deliveryTimeOffer: DeliveryTimeOffer
    onClose: () => void
}

const Popover: FC<PopoverProps> = ({ open, deliveryTimeOffer, onClose }) => {
    const days = useAvailableDays(deliveryTimeOffer)

    const [day, handleDayChange] = useDay(days)

    const times = useAvailableTimes(deliveryTimeOffer, day)

    const screenSize = useScreenSize()

    return (
        <DismissOverlayProvider open={open}>
            <View style={[styles.container, screenSize === 'large' && styles.largeContainer]}>
                <View style={styles.field}>
                    <DaySelector days={days} day={day} onChange={handleDayChange} />
                </View>
                <View style={styles.field}>
                    <TimeSelector times={times} onSelect={onClose} />
                </View>
            </View>
        </DismissOverlayProvider>
    )
}

export default Popover

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 12,
    },
    largeContainer: {
        padding: 16,
    },
    field: {
        flex: 1,
        minWidth: 0,
    },
})
